const listOfModifierAttributes = ['ctrlKey', 'shiftKey', 'altKey', 'metaKey'];

const hasModifier = (keyDownEvent) => {
  const eventHasModifierOn = (isOn, modifierAttribute) => {
    return isOn || keyDownEvent[modifierAttribute];
  };

  return listOfModifierAttributes.reduce(eventHasModifierOn, false);
};

export default hasModifier;
